import { Reveal } from "@/components/Reveal";

const PARTNERS = [
  "MAISON AL NOOR",
  "GULF & CARAT",
  "ATELIER VERMEER",
  "LUMIÈRE FINE JEWELS",
  "DESERT ROSE JEWELLERY",
  "ALMAS & SONS",
];

export const TrustedByLogos = () => (
  <section data-testid="trusted-by-logos" className="mx-auto max-w-7xl px-6 py-20 lg:px-12">
    <Reveal>
      <p className="eyebrow mb-10 text-center" data-testid="trusted-by-label">
        Trusted by the trade
      </p>
      <div className="grid grid-cols-2 gap-x-8 gap-y-8 sm:grid-cols-3 lg:grid-cols-6">
        {PARTNERS.map((name, i) => (
          <div
            key={name}
            data-testid={`trusted-logo-${i}`}
            className="flex items-center justify-center opacity-35 transition-all duration-500 hover:opacity-90"
          >
            <span className="font-display text-center text-sm font-medium tracking-[0.22em] text-white">
              {name}
            </span>
          </div>
        ))}
      </div>
      <p className="mt-10 text-center text-[11px] uppercase tracking-[0.2em] text-[#717680]" data-testid="trusted-by-note">
        Representative houses — permissioned client logos placed before launch
      </p>
    </Reveal>
  </section>
);
